// TO DEFINE THE STATES AND CHANGE STATUS
import { createSlice } from '@reduxjs/toolkit';
import { fetchViolations, updateViolation } from './violationsThunks';

const initialState = {
  violations: [],
  selectedWeek: null,
  totalViolations: 0,
  selectedViolation: null,
  isDrawerOpen: false,
  activeFilter: 'ALL',
  status: 'idle',
  updatingStatus: 'idle',
  error: null,
};

const violationsReportSlice = createSlice({
  name: 'violationsReport',
  initialState,
  reducers: {
    setSelectedWeek: (state, action) => {
      state.violations = []; // Clean the Violations
      state.selectedWeek = action.payload;
    },
    setSelectedViolation: (state, action) => {
      state.selectedViolation = null; // Clean the selectedViolation
      state.selectedViolation = action.payload;
      state.isDrawerOpen = true;
    },
    setCleanViolation: (state) => {
      state.selectedViolation = null; // Clean the selectedViolation
      state.isDrawerOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchViolations.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchViolations.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.violations = action.payload;
        state.totalViolations = state.violations.length || 0; // the 0 is to avoid errors
        state.lastUpdate = new Date().toISOString();
      })
      .addCase(fetchViolations.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(updateViolation.pending, (state) => {
        state.updatingStatus = 'loading';
      })
      .addCase(updateViolation.fulfilled, (state, action) => {
        state.updatingStatus = 'succeeded';
        state.selectedViolation = action.payload;
        state.violations = state.violations.map((violation) =>
          violation.id === action.payload.id ? action.payload : violation
        );
      })
      .addCase(updateViolation.rejected, (state, action) => {
        state.updatingStatus = 'failed';
        state.error = action.payload;
      });
  },
});

export const { setSelectedWeek, setSelectedTypeFilter, setSelectedViolation, setCleanViolation } =
  violationsReportSlice.actions;

export const selectViolations = (state) => state.violationsReport.violations;
export const selectSelectedViolation = (state) => state.violationsReport.selectedViolation;
export const selectSelectedViolationId = (state) => state.violationsReport.selectedViolation?.id || null;
export const selectIsDrawerOpen = (state) => state.violationsReport.isDrawerOpen;
export const selectTotalViolations = (state) => state.violationsReport.totalViolations;
export const selectViolationsStatus = (state) => state.violationsReport.status;
export const selectSelectedWeek = (state) => state.violationsReport.selectedWeek;

export default violationsReportSlice.reducer;
